import React, { Component } from 'react';
import { connect } from 'react-redux';

class EventItem extends Component {
    render() {
      return (  
          <a href={this.props.hit.url}>    
            <div className="row row-eq-height align-items-center listing__item" key={this.props.hit.externalUrl}>
                <div className="col-sm-2 col-lg-1 listing__date">
                    <time className="time--large">{this.props.hit.formattedMonth}<strong>{this.props.hit.formattedDay}</strong></time>
                </div>
                <div className="col-sm-10 col-lg-11">
                    <div className="listing__description">
                        <p>{this.props.hit.eventDuration}</p>
                        <h3>{this.props.hit.heading}</h3>
                        {this.props.hit.description} 
                    </div>
                </div>
            </div>
          </a>
        );
    }
}


export default EventItem;